module.exports = __webpack_public_path__ + "img/marketing.82702baa.svg";